// ============================================================
// CritThresholdChart - Critical severity probability bars.
// Color gradient from green (low severity) to red (high/death).
// ============================================================
import BarChart from './BarChart';
import type { CritDistribution } from '../../engine/probability';

interface Props {
  data: CritDistribution;
}

/** Severity → color gradient (green 1-3, yellow 4-6, red 7-10). */
function sevColor(sev: number): string {
  if (sev <= 3) return '#86efac';
  if (sev <= 6) return '#fbbf24';
  if (sev <= 8) return '#f87171';
  return '#dc2626';
}

export default function CritThresholdChart({ data }: Props) {
  // Show severities 1–10 (skip index 0)
  const bars = [];
  for (let s = 1; s <= 10; s++) {
    bars.push({
      label: String(s),
      value: data.severityProbs[s] || 0,
      color: sevColor(s),
    });
  }

  return <BarChart data={bars} showValues formatValue={(v) => (v * 100).toFixed(0) + '%'} maxValue={1} />;
}
